import React from 'react';
import './QuestionModal.css';
export default function QuestionModal({ isOpen, question, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="question-modal-overlay">
      <div className="question-modal">
        <p>{question}</p>
        <div className="question-modal-actions">
          <button onClick={() => onClose(true)}>OK</button>
          <button onClick={() => onClose(false)}>Cancel</button>
        </div>
      </div>
    </div>
  );
}
